<template>
    
    <div class="p-4 flex items-center space-x-4 cursor-pointer" @click="$router.push('/profile')" >

        <p class="flex-grow text-right font-medium whitespace-no-wrap" >JANE D.</p>

        <div class="w-10 min-w-10 h-10 rounded-full flex items-center justify-center bg-gray-600" >

            <img draggable="false" src="/images/icons/user.svg" alt="user" >

        </div>

    </div>

</template>

<script>

    export default {

        name: 'User Card'

    }

</script>